const ORDINAL_WORD_TO_DIGIT: Readonly<Record<string, string>> = {
    zeroth: '0',
    first: '1',
    second: '2',
    third: '3',
    fourth: '4',
    fifth: '5',
    sixth: '6',
    seventh: '7',
    eighth: '8',
    ninth: '9',
    tenth: '10',
    eleventh: '11',
    twelfth: '12',
    thirteenth: '13',
    fourteenth: '14',
    fifteenth: '15',
    sixteenth: '16',
    seventeenth: '17',
    eighteenth: '18',
    nineteenth: '19',
    twentieth: '20'
};

const normalizeWordForOrdinal = (word: string): string =>
    word
        .replace(/^['\u2019`]+/, '')
        .replace(/[,;.:!?)}\]]+$/u, '')
        .trim()
        .toLowerCase();

const NUMERIC_ORDINAL_PATTERN = /^(\d+)(?:st|nd|rd|th)$/;

const abbreviateRoleWord = (rawWord: string): string => {
    const word = rawWord.trim();
    if (!word) return '';

    const forOrdinal = normalizeWordForOrdinal(word);
    const ordinalWord = ORDINAL_WORD_TO_DIGIT[forOrdinal];
    if (ordinalWord) return ordinalWord;

    const numericOrdinal = forOrdinal.match(NUMERIC_ORDINAL_PATTERN);
    if (numericOrdinal) return numericOrdinal[1];

    const letterMatch = word.match(/\p{L}/u);
    if (letterMatch) return letterMatch[0].toUpperCase();

    const digitMatch = word.match(/\p{N}/u);
    if (digitMatch) return digitMatch[0];

    return '';
};

const abbreviateSingleRoleLabel = (role: string): string => {
    const trimmed = role.trim();
    if (!trimmed) return '';

    const words = trimmed.split(/\s+/u).filter(Boolean).slice(0, 3);
    return words.map(abbreviateRoleWord).join('');
};

export const formatRolesLabel = (roles: ReadonlyArray<string | null | undefined> | null | undefined): string => {
    if (!roles) return '';

    const segments: string[] = [];
    for (const raw of roles) {
        if (!raw?.trim()) continue;
        for (const part of raw.split(',')) {
            const trimmed = part.trim();
            if (trimmed) segments.push(trimmed);
        }
    }

    return segments
        .map((role) => abbreviateSingleRoleLabel(role))
        .filter(Boolean)
        .join(',');
};
